module.exports = __webpack_public_path__ + "img/ten.be5030ca.webp";